import React, { BaseSyntheticEvent } from "react";
import { TextField, Box, FormGroup, FormControlLabel, Checkbox, Switch } from "@mui/material"
import { useTranslation } from "react-i18next";

// MUI
import SearchIcon from '@mui/icons-material/Search';

//Types
import { ThumbFilters } from "./ObjectAnalysisThumbs";

type ObjectAnalysisThumbsFilterProps = {
  filterObject: ThumbFilters,
  onFilterChange: any,
  recordsLength: number,
  filteredRecrodsLength: number
}

function ObjectAnalysisThumbsFilter(props: ObjectAnalysisThumbsFilterProps) {
  const { filterObject, onFilterChange, recordsLength, filteredRecrodsLength } = props
  const { t } = useTranslation();

  function handleSetFilter(e: BaseSyntheticEvent) {
    const name = e.target.name

    let newFilter = { ...filterObject }
    if (name === "text") {
      newFilter.textFilter = e.target.value;
    } else if (name === "selected") {
      newFilter.selectedFilter = e.target.checked;
      if (e.target.checked === true) {
        newFilter.notSelectedFiter = false;
      }
    } else if (name === "notselected") {
      newFilter.notSelectedFiter = e.target.checked;
      if (e.target.checked === true) {
        newFilter.selectedFilter = false;
      }
    } else if (name === "reddots") {
      newFilter.redDotsFilter = e.target.checked;
    } else if (name === "freeflight") {
      newFilter.freeFlightFilter = e.target.checked;
    }
    onFilterChange(newFilter)
  }

  const hasRecords = recordsLength > 0 ? true : false;

  return (
    <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
      <TextField
        sx={{ ml: 3, mr: 3 }}
        variant='standard'
        margin='dense'
        name='text'
        value={filterObject.textFilter || ""}
        placeholder={t("common.search_count_placeholder", { filteredCount: filteredRecrodsLength, totalCount: recordsLength })}
        InputProps={{
          startAdornment: <SearchIcon />
        }}
        onChange={handleSetFilter}
        disabled={!hasRecords}
      />
      <FormControlLabel 
        control={<Switch checked={filterObject.selectedFilter} />} 
        disabled={!hasRecords} 
        name="selected" 
        label={t("buttons._filter_selected") as string} 
        onChange={handleSetFilter} 
      />
      <FormControlLabel 
        control={<Switch checked={filterObject.notSelectedFiter} />} 
        disabled={!hasRecords} 
        name="notselected" 
        label={t("buttons._filter_notselected") as string} 
        onChange={handleSetFilter} 
      />
      <FormControlLabel 
        control={<Switch checked={filterObject.redDotsFilter} />} 
        disabled={!hasRecords} 
        name="reddots" 
        label={t("buttons._filter_reddots") as string} 
        onChange={handleSetFilter} 
      />
      <FormControlLabel 
        control={<Switch checked={filterObject.freeFlightFilter} />} 
        disabled={!hasRecords} 
        name="freeflight" 
        label={t("buttons._filter_freeflight") as string} 
        onChange={handleSetFilter} 
      />
    </Box>
  )
}

export default ObjectAnalysisThumbsFilter